import { AppLanguageCode } from 'entities/application';
import { AppThunk } from 'store';

import * as storageLocale from 'i18n/storageLocale';

import { applicationActions } from "../reducer";

export const setLocale = (locale: AppLanguageCode): AppThunk => async (dispatch) => {
  dispatch(applicationActions.setLocale(locale));
  storageLocale.setLocale(locale);
};
